import { render } from "./RefreshIcon.vue?vue&type=template&id=39677e06"
const script = {}
script.render = render

export default script